import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["userId", "options"],
    _excluded2 = ["message", "options"],
    _excluded3 = ["error", "options"],
    _excluded4 = ["page", "options"];
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { merge } from 'lodash';
import init from './init';
import * as CONST from '../../constants';

var transformData = function transformData(data) {
  return data;
};

export default (function (_ref, appName) {
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case CONST.INIT:
      {
        var _window$analytics, _window$analytics$loa;

        if (!(payload !== null && payload !== void 0 && payload.id)) {
          return;
        }

        if (payload !== null && payload !== void 0 && payload.transformData) {
          transformData = payload.transformData;
        } // Analytics.init({ id: apiKey })
        // Load Analytics.js with your key, which will automatically
        // load the tools you've enabled for your account. Boosh!


        init();
        (_window$analytics = window.analytics) === null || _window$analytics === void 0 ? void 0 : (_window$analytics$loa = _window$analytics.load) === null || _window$analytics$loa === void 0 ? void 0 : _window$analytics$loa.call(_window$analytics, payload === null || payload === void 0 ? void 0 : payload.id);
        break;
      }

    case CONST.IDENTIFY:
      {
        var _window$analytics2, _window$analytics2$id;

        var _ref2 = payload || {},
            userId = _ref2.userId,
            options = _ref2.options,
            rest = _objectWithoutProperties(_ref2, _excluded);

        if (!userId) {
          console.error("No \"userId\" found in payload!");
          return;
        }

        (_window$analytics2 = window.analytics) === null || _window$analytics2 === void 0 ? void 0 : (_window$analytics2$id = _window$analytics2.identify) === null || _window$analytics2$id === void 0 ? void 0 : _window$analytics2$id.call(_window$analytics2, userId, merge({}, rest, {
          appName: appName
        }), options);
        break;
      }

    case CONST.CUSTOM:
      {
        var _window$analytics3, _window$analytics3$tr;

        // Analytics.custom({ eventName, data, options })
        var _ref3 = payload || {},
            eventName = _ref3.eventName,
            _ref3$data = _ref3.data,
            data = _ref3$data === void 0 ? {} : _ref3$data,
            _options = _ref3.options;

        var _ref4 = _options || {},
            callback = _ref4.callback;

        (_window$analytics3 = window.analytics) === null || _window$analytics3 === void 0 ? void 0 : (_window$analytics3$tr = _window$analytics3.track) === null || _window$analytics3$tr === void 0 ? void 0 : _window$analytics3$tr.call(_window$analytics3, eventName, merge({}, transformData(data), {
          appName: appName
        }), merge({}, {
          integrations: {
            FullStory: false,
            NewRelic: false
          }
        }, _options), callback);
        break;
      }

    case CONST.INFORMATION:
      {
        var _window$analytics4, _window$analytics4$tr;

        // Analytics.information({ message, options, ... })
        var _ref5 = payload || {},
            message = _ref5.message,
            _options2 = _ref5.options,
            _rest = _objectWithoutProperties(_ref5, _excluded2);

        (_window$analytics4 = window.analytics) === null || _window$analytics4 === void 0 ? void 0 : (_window$analytics4$tr = _window$analytics4.track) === null || _window$analytics4$tr === void 0 ? void 0 : _window$analytics4$tr.call(_window$analytics4, 'Information', merge({}, _objectSpread({
          Message: message,
          appName: appName
        }, transformData(_rest))), merge({}, {
          integrations: {
            FullStory: false,
            NewRelic: false,
            Intercom: false
          }
        }, _options2));
        break;
      }

    case CONST.TRACK:
      {
        var _window$analytics5, _window$analytics5$tr;

        // Analytics.track({ options, ... })
        var _ref6 = payload || {},
            _eventName = _ref6.eventName,
            _ref6$data = _ref6.data,
            _data = _ref6$data === void 0 ? {} : _ref6$data,
            _options3 = _ref6.options;

        (_window$analytics5 = window.analytics) === null || _window$analytics5 === void 0 ? void 0 : (_window$analytics5$tr = _window$analytics5.track) === null || _window$analytics5$tr === void 0 ? void 0 : _window$analytics5$tr.call(_window$analytics5, _eventName, merge({}, transformData(_data), {
          appName: appName
        }), merge({}, {
          integrations: {
            NewRelic: false,
            Intercom: false
          }
        }, _options3));
        break;
      }

    case CONST.ERROR:
      {
        var _error$message;

        // Analytics.error({ error, options, ... })
        var _ref7 = payload || {},
            error = _ref7.error,
            _options4 = _ref7.options,
            _rest2 = _objectWithoutProperties(_ref7, _excluded3);

        window.analytics.track('Error', merge({}, _objectSpread({
          Error: (_error$message = error === null || error === void 0 ? void 0 : error.message) !== null && _error$message !== void 0 ? _error$message : error,
          appName: appName
        }, transformData(_rest2))), merge({}, {
          integrations: {
            FullStory: false,
            NewRelic: false,
            Intercom: false
          }
        }, _options4));
        break;
      }

    case CONST.NAVIGATION:
      {
        var _window$analytics6, _window$analytics6$pa, _window$Intercom, _window;

        // Analytics.navigation({ page, options, ... })
        var _ref8 = payload || {},
            page = _ref8.page,
            _options5 = _ref8.options,
            _rest3 = _objectWithoutProperties(_ref8, _excluded4);

        (_window$analytics6 = window.analytics) === null || _window$analytics6 === void 0 ? void 0 : (_window$analytics6$pa = _window$analytics6.page) === null || _window$analytics6$pa === void 0 ? void 0 : _window$analytics6$pa.call(_window$analytics6, page, transformData(_rest3), // Intercom is not hit because we need to trigger an 'update' directly
        // otherwise they don't update the recent pages
        merge({}, {
          integrations: {
            Intercom: false
          }
        }, _options5));
        (_window$Intercom = (_window = window).Intercom) === null || _window$Intercom === void 0 ? void 0 : _window$Intercom.call(_window, 'update', {
          // eslint-disable-next-line
          last_request_at: _parseInt((new Date().getTime() / 1000).toString())
        });
        break;
      }

    default:
      console.warn("Unknown event type: ".concat(type));
  }
});